import { FormGroup } from "@angular/forms";
import { ReferenceValueDto } from "@sharedcommon/rest/data.restservice";

export class ReferenceValueAndFormForCal {
    /** La référence value dont provient l'objet */
    referenceValue: ReferenceValueDto;

    /** Le formulaire qui sera utilisé dans le composant */
    form: FormGroup ;
}